/**
 * PolicySlice Procedure Codes Reducers
 * 
 * Reducers for managing effective procedure codes on policies.
 */

import { PayloadAction, CaseReducer } from '@reduxjs/toolkit';
import { PolicySliceState } from '../state';

// =============================================================================
// PROCEDURE CODES REDUCERS
// =============================================================================

/**
 * Add a procedure code to the policy
 */
export const addProcedureCode: CaseReducer<PolicySliceState, PayloadAction<string>> = (
  state,
  action
) => {
  if (state.currentPolicy && !state.currentPolicy.effectiveProcedureCodes.includes(action.payload)) {
    state.currentPolicy.effectiveProcedureCodes.push(action.payload);
    state.isEdited = true;
    if (!state.editedFields.includes('effectiveProcedureCodes')) {
      state.editedFields.push('effectiveProcedureCodes');
    }
  }
};

/**
 * Remove a procedure code from the policy
 */
export const removeProcedureCode: CaseReducer<PolicySliceState, PayloadAction<string>> = (
  state,
  action
) => {
  if (state.currentPolicy) {
    state.currentPolicy.effectiveProcedureCodes = state.currentPolicy.effectiveProcedureCodes.filter(
      (code) => code !== action.payload
    );
    state.isEdited = true;
    if (!state.editedFields.includes('effectiveProcedureCodes')) {
      state.editedFields.push('effectiveProcedureCodes');
    }
  }
};

/**
 * Set all procedure codes at once
 */
export const setProcedureCodes: CaseReducer<PolicySliceState, PayloadAction<string[]>> = (
  state,
  action
) => {
  if (state.currentPolicy) {
    state.currentPolicy.effectiveProcedureCodes = action.payload;
    state.isEdited = true;
    if (!state.editedFields.includes('effectiveProcedureCodes')) {
      state.editedFields.push('effectiveProcedureCodes');
    }
  }
};
